let authorizationLookup = {};

authorizationLookup.dashboard = {
  DASHBOARD: { view: true },
};

authorizationLookup.usersTable = {
  USER: {
    view: true,
    create: false,
    delete: false,
    edit: false,
    multipleCreate: false,
  },
};

authorizationLookup.signInHistory = {
  SIGN_IN_HISTORY: { view: true, export: true, exportAll: true },
};

authorizationLookup.gdzProdAppUpdate = {
  GDZ_PROD_FULL: { view: true, create: true },
  GDZ_PROD_READ_ONLY: { view: true, create: false },
};
authorizationLookup.admProdAppUpdate = {
  ADM_PROD_FULL: { view: true, create: true },
  ADM_PROD_READ_ONLY: { view: true, create: false },
};
authorizationLookup.gdzadmDevAppUpdate = {
  GDZ_ADM_DEV_FULL: { view: true, create: true },
  GDZ_ADM_DEV_READ_ONLY: { view: true, create: false },
};
authorizationLookup.gdzadmTestAppUpdate = {
  GDZ_ADM_TEST_FULL: { view: true, create: true },
  GDZ_ADM_TEST_READ_ONLY: { view: true, create: false },
};

authorizationLookup.medasDevAppUpdate = {
  MEDAS_DEV_FULL: { view: true, create: true },
  MEDAS_DEV_READ_ONLY: { view: true, create: false },
};
authorizationLookup.medasTestAppUpdate = {
  MEDAS_TEST_FULL: { view: true, create: true },
  MEDAS_TEST_READ_ONLY: { view: true, create: false },
};
authorizationLookup.medasProdAppUpdate = {
  MEDAS_PROD_FULL: { view: true, create: true },
  MEDAS_PROD_READ_ONLY: { view: true, create: false },
};

authorizationLookup.vedasDevAppUpdate = {
  VEDAS_DEV_FULL: { view: true, create: true },
  VEDAS_DEV_READ_ONLY: { view: true, create: false },
};
authorizationLookup.vedasProdAppUpdate = {
  VEDAS_PROD_FULL: { view: true, create: true },
  VEDAS_PROD_READ_ONLY: { view: true, create: false },
};

authorizationLookup.oedasDevAppUpdate = {
  OEDAS_DEV_FULL: { view: true, create: true },
  OEDAS_DEV_READ_ONLY: { view: true, create: false },
};
authorizationLookup.oedasProdAppUpdate = {
  OEDAS_PROD_FULL: { view: true, create: true },
  OEDAS_PROD_READ_ONLY: { view: true, create: false },
};

authorizationLookup.yedasDevAppUpdate = {
  YEDAS_DEV_FULL: { view: true, create: true },
  YEDAS_DEV_READ_ONLY: { view: true, create: false },
};
authorizationLookup.yedasProdAppUpdate = {
  YEDAS_PROD_FULL: { view: true, create: true },
  YEDAS_PROD_READ_ONLY: { view: true, create: false },
};

authorizationLookup.zorenDevAppUpdate = {
  ZOREN_DEV_FULL: { view: true, create: true },
  ZOREN_DEV_READ_ONLY: { view: true, create: false },
};
authorizationLookup.zorenProdAppUpdate = {
  ZOREN_PROD_FULL: { view: true, create: true },
  ZOREN_PROD_READ_ONLY: { view: true, create: false },
};

authorizationLookup.isghubAppUpdate = {
  ISGHUB_FULL: { view: true, create: true },
};

authorizationLookup.isgdemoAppUpdate = {
  DEMO_FULL: { view: true, create: true },
  DEMO_READ_ONLY: { view: true, create: false },
};

authorizationLookup.documentationHubAppUpdate = {
  DOCUMENTATIONHUB_FULL: { view: true, create: true },
  DOCUMENTATIONHUB_READ_ONLY: { view: true, create: false },
};

authorizationLookup.pincidentPublicAppUpdate = {
  PINCIDENTPUBLIC_FULL: { view: true, create: true },
  PINCIDENTPUBLIC_READ_ONLY: { view: true, create: false },
};

authorizationLookup.idealKontratAppUpdate = {
  IDEALKONTRAT_FULL: { view: true, create: true },
  IDEALKONTRAT_READ_ONLY: { view: true, create: false },
};

authorizationLookup.osgbIzlemeIsgProfessionals = {
  OSGB_IZLEME_FULL: { view: true, create: true, edit: true, delete: true },
  OSGB_IZLEME_READ_ONLY: {
    view: true,
    create: false,
    edit: false,
    delete: false,
  },
};

authorizationLookup.tickets = {
  TICKET: {
    view: true,
    create: false,
    delete: false,
    edit: false,
    multipleCreate: false,
  },
};

export function getViewAuthorizationForAll(permissions) {
  let authorization = {};
  console.log("Permissions:", permissions);

  if (!Array.isArray(permissions)) {
    console.warn("No permission list on the session user.");
    return authorization;
  }

  for (let i = 0; i < permissions.length; i++) {
    for (let page in authorizationLookup) {
      if (page !== "dashboard") {
        const pagePermissions = authorizationLookup[page];
        const permissionEntry = pagePermissions[permissions[i]];

        if (permissionEntry && typeof permissionEntry.view !== "undefined") {
          authorization[page] = authorization[page] || permissionEntry.view;
        }
      }
    }
  }
  console.log("Authorization:", authorization);
  return authorization;
}

export function getAuthorizationForPage(permissions, page) {
  let authorization = {};

  // Check if the page exists in the lookup
  const pagePermissions = authorizationLookup[page];
  if (!pagePermissions) {
    console.warn(`Page "${page}" not found in authorizationLookup.`);
    return authorization;
  }

  if (!Array.isArray(permissions)) {
    console.warn("No permission list on the session user.");
    return authorization;
  }

  for (let i = 0; i < permissions.length; i++) {
    const permissionKey = permissions[i];
    const permissionEntry = pagePermissions[permissionKey];

    if (!permissionEntry) {
      console.warn(
        `Permission "${permissionKey}" not found for page "${page}".`,
      );
      continue;
    }

    for (let prop in permissionEntry) {
      authorization[prop] = authorization[prop] || permissionEntry[prop];
    }
  }

  return authorization;
}
